// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-info__icon-hover[data-v-4e83c65e]:hover {\n  opacity: 0.7;\n}", ""]);
// Exports
module.exports = exports;
